var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Configurator } from '@api/services/configurator';
import { BasketAssistant } from '@api/services/basket';
import config from '@api/config';
var QuantityCtaDropdown = /*@__PURE__*/ (function () {
    function QuantityCtaDropdown(container) {
        this.template = "    <div class=\"qty-select-wrapper\">\n" +
            "                                    <select class=\"qty-select\"></select>\n" +
            "                                    <span class=\"qty-select-placeholder\">\n" +
            "                                                    <span></span>\n" +
            "                                                    <svg class=\"i-sml\">\n" +
            "                                                        <use xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n" +
            "                                                             xlink:href=\"/simplicity/svgdefs.svg#i-caret-down-sml\"></use>\n" +
            "                                                    </svg>\n" +
            "                                                </span>\n" +
            "                                </div>";
        this.container = container;
        var tariffId = parseInt(this.container.getAttribute('data-tariff-id'));
        if (config.CBU_CHECKOUT_TARIFF_IDS.includes(tariffId)) {
            this.container.parentNode.removeChild(this.container);
            return;
        }
        ;
        this.init();
    }
    QuantityCtaDropdown.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.container.innerHTML = this.template;
                        _a = this;
                        return [4 /*yield*/, BasketAssistant.getTotalAmount()];
                    case 1:
                        _a.basketItemsAmount = _b.sent();
                        this.setQty();
                        this.setAmountDropdownOnChange();
                        Configurator.subscribe('offerChanged', this.onOfferChanged.bind(this));
                        this.onOfferChanged();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuantityCtaDropdown.prototype.setQty = function () {
        jQuery('.qty-select option').remove();
        var maxQty = BasketAssistant.MAX_ITEMS_ALLOWED - this.basketItemsAmount;
        for (var i = 1; i <= maxQty; i++) {
            var optionElement = document.createElement('option');
            optionElement.value = i + '';
            optionElement.innerHTML = i + '';
            jQuery('.qty-select').append(optionElement);
        }
        if (maxQty === 0) {
            jQuery('.wrapper-cta-container').addClass('maxBasketQtyReached');
            jQuery('qty-select-placeholder').text('0');
        }
    };
    QuantityCtaDropdown.prototype.onOfferChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAmount(Configurator.getAmount())];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuantityCtaDropdown.prototype.setAmountDropdownOnChange = function () {
        var _this = this;
        var amountSelectEl = Array.prototype.slice.call(document.querySelectorAll('select.qty-select'));
        amountSelectEl.forEach(function (amountSelectEl) {
            amountSelectEl.addEventListener('change', function (e) { return _this.handleAmountChanged(e); });
        });
    };
    QuantityCtaDropdown.prototype.handleAmountChanged = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var amount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        amount = parseInt(e.srcElement.value);
                        if (this.basketItemsAmount + amount > BasketAssistant.MAX_ITEMS_ALLOWED) {
                            amount = BasketAssistant.MAX_ITEMS_ALLOWED - this.basketItemsAmount;
                        }
                        return [4 /*yield*/, Configurator.setAmount(amount)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Configurator.handleOfferChanged()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuantityCtaDropdown.prototype.updateAmount = function (amount) {
        return __awaiter(this, void 0, void 0, function () {
            var amountSelectEl, maxAmount, qtyPlaceholder;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        amountSelectEl = Array.prototype.slice.call(document.querySelectorAll('select.qty-select'));
                        maxAmount = amount + this.basketItemsAmount < BasketAssistant.MAX_ITEMS_ALLOWED ? amount : BasketAssistant.MAX_ITEMS_ALLOWED - this.basketItemsAmount;
                        return [4 /*yield*/, amountSelectEl.forEach(function (amountSelectEl) {
                                amountSelectEl.value = maxAmount + '';
                            })];
                    case 1:
                        _a.sent();
                        qtyPlaceholder = amount;
                        if (!(amount > BasketAssistant.MAX_ITEMS_ALLOWED - this.basketItemsAmount))
                            return [3 /*break*/, 3];
                        qtyPlaceholder = maxAmount;
                        return [4 /*yield*/, Configurator.setAmount(maxAmount)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        jQuery('.qty-select-placeholder > span').text(qtyPlaceholder);
                        return [2 /*return*/];
                }
            });
        });
    };
    return QuantityCtaDropdown;
}());
export default QuantityCtaDropdown;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/shared/QuantityCtaDropdown.ts
// module id = null
// module chunks = 